import { ReactComponent as MenuIcon } from "../img/icons/icon_menuhamburger.svg";
import { ReactComponent as LibraryIcon } from "../img/icons/icon_library.svg";
import { useEffect, useState } from "react";
import { Offcanvas } from "react-bootstrap";
import UserProfileIcon from "../img/userprofile.png";
import UserProfileIconSmall from "../img/icons/icon_profile.png";
import SettingsIcon from "../img/icons/icon_setting.png";
import AboutIcon from "../img/icons/icon_about.png";
import SecurityIcon from "../img/icons/icon_secrity.png";
import SignoutIcon from "../img/icons/icon_signout.png";
import ShareAltIcon from "../img/icons/icon_sharealt.png";
import { Link, useHistory } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { formatPID, getFullName, isUnauthorised } from "../utils";
import createPersistedState from "use-persisted-state";

import { messaging, deleteToken, FCM_TOKEN_KEY } from "../firebase";
const useClinicState = createPersistedState("clinic");
const useProfileState = createPersistedState("profile");
const useToken = createPersistedState("token");

function SideNav() {
  const [show, setShow] = useState(false);

  // patient detail
  const [patientDetail, setPatientDetail] = useState({});
  const [___, setClinic] = useClinicState();
  const [____, setProfile] = useProfileState();
  const [token, setToken] = useToken();

  const [isLogoutLoading, setIsLogoutLoading] = useState(false);

  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);
  const { t } = useTranslation();

  // logout
  const history = useHistory();

  const logoutHandler = async (e) => {
    if (e && typeof e.preventDefault === "function") e.preventDefault();
    setIsLogoutLoading(true);

    try {
      const authToken = token;
      const patientId = JSON.parse(localStorage.getItem("pid")) || null;
      const fcmToken = localStorage.getItem(FCM_TOKEN_KEY) || null;

      if (!fcmToken) {
        // No token -> proceed immediately with cleanup
        console.log("No FCM token cached, skipping deleteToken/server call.");
      } else {
        // We have a token: try to delete client-side first (best-effort)
        try {
          const deleted = await deleteToken(messaging); // boolean or throws
          if (deleted === true) {
            console.log("FCM token deleted from client ");
          } else {
            // deleted === false means there was no token to delete on the client side
            console.warn(
              "deleteToken returned false (no token to delete client-side)"
            );
          }
        } catch (err) {
          // don't block logout for SDK errors — log and continue
          console.warn("deleteToken threw an error; continuing logout:", err);
        }

        // Inform server to remove mapping (best-effort)
        if (patientId) {
          try {
            const url = `/api/v1/users/fcm?patientId=${encodeURIComponent(
              patientId
            )}&fcmToken=${encodeURIComponent(fcmToken)}`;

            const res = await fetch(url, {
              method: "PATCH",
              headers: {
                "Content-Type": "application/json",
                Authorization: `Bearer ${authToken}`,
              },
            });

            if (!res.ok) {
              const text = await res.text().catch(() => "");
              console.warn(
                "Server responded non-OK while removing FCM token:",
                res.status,
                text
              );
            } else {
              console.log("Requested server to remove FCM token");
            }
          } catch (err) {
            console.warn("Failed to call server to remove FCM token:", err);
          }
        } else {
          console.log("No patientId available - skipping server removal");
        }
      }

      // Now perform local cleanup (always)
      localStorage.removeItem("token");
      localStorage.removeItem("pid");
      localStorage.removeItem("Date");
      localStorage.removeItem("i18nextLng");
      localStorage.removeItem("clinic");
      localStorage.removeItem("onboardingHist");
      localStorage.removeItem("isChatButtonEnabled");
      localStorage.removeItem("profile");
      localStorage.removeItem(FCM_TOKEN_KEY);

      // Redirect to login (replace so Back doesn't return to protected pages)
      history.replace("/login");
    } finally {
      setIsLogoutLoading(false);
    }
  };

  //fetch past appointment
  const patientId = JSON.parse(localStorage.getItem("pid"));
  const URL = `/api/v1/users/profile/${patientId}`;
  useEffect(() => {
    const profileData = async () => {
      const token = "Bearer " + localStorage.getItem("token");
      try {
        const response = await fetch(URL, {
          method: "GET",
          headers: {
            Accept: "application/json; charset=utf-8",
            "Content-Type": "application/json",
            Authorization: token.replace(/['"]+/g, ""),
          },
          credentials: "include",
        });
        const data = await response.json();
        //console.log(response.status);
        //console.log(data);
        // console.log(data.profile);
        if (response.status !== 200) {
          if (isUnauthorised(data.status)) {
            localStorage.clear();
            history.push("/login");
          }
          const error = new Error(response.error);
          throw error;
        } else {
          setProfile(data["profile"]);
          setPatientDetail(data.profile);
          const clinicId = data["profile"]["clinicId"];
          setClinic(clinicId);
        }
      } catch (err) {
        console.log(err);
      }
    };
    profileData();
  }, [URL]);

  return (
    <>
      <header className="border_bottom">
        <div className="inner_header">
          <Link
            to="#"
            onClick={handleShow}
            className="icon_left"
            id="menu_hamburger"
          >
            <MenuIcon alt="" className="img-fluid" />
          </Link>
          {/* <Link to="/library" className="icon_right">
            <LibraryIcon className="img-fluid" />
          </Link> */}
        </div>
      </header>
      <Offcanvas show={show} onHide={handleClose}>
        <div className="sidebar_fullscreen" id="sidebar_fullscreen">
          <div className="inner_content_sidebar">
            <Offcanvas.Title>
              <Link
                to="#"
                onClick={handleClose}
                id="icon_close_hamburger"
                className="icon_close d-flex justify-content-end"
              >
                ×
              </Link>
              <div className="head_sidebar d-flex align-items-center">
                <div className="thumb">
                  <img
                    src={UserProfileIcon}
                    alt=""
                    className="img-fluid img_fit"
                  />
                </div>
                <div className="caption">
                  <h3 className="subtitle">{getFullName(patientDetail)}</h3>
                  <p className="txt_id">
                    {t("sidenav.MY-PROFILE.patientid")} :{" "}
                    {formatPID(patientDetail.patientId)}
                  </p>
                </div>
              </div>
            </Offcanvas.Title>
            <Offcanvas.Body>
              <div className="body_siderbar">
                <ul className="list-unstyled list_navbar">
                  <li>
                    <Link to="/my-profile">
                      <span className="iconnav">
                        <img
                          src={UserProfileIconSmall}
                          alt=""
                          className="img-fluid"
                        />
                      </span>
                      <span className="txt">{t("sidenav.PROFILE.detail")}</span>
                    </Link>
                  </li>
                  <li>
                    <Link to="/setting">
                      <span className="iconnav">
                        <img src={SettingsIcon} alt="" className="img-fluid" />
                      </span>
                      <span className="txt">{t("sidenav.SETTING.detail")}</span>
                    </Link>
                  </li>
                  <li>
                    <Link to="/refer-friend">
                      <span className="iconnav">
                        <img src={ShareAltIcon} alt="" className="img-fluid" />
                      </span>
                      <span className="txt">{t("sidenav.FRIEND.detail")}</span>
                    </Link>
                  </li>
                  <li>
                    <Link to="#">
                      <span className="iconnav">
                        <img src={AboutIcon} alt="" className="img-fluid" />
                      </span>
                      <span className="txt">{t("sidenav.ABOUT.detail")}</span>
                    </Link>
                  </li>
                  <li>
                    <Link to="#">
                      <span className="iconnav">
                        <img src={SecurityIcon} alt="" className="img-fluid" />
                      </span>
                      <span className="txt">{t("sidenav.PRIVACY.detail")}</span>
                    </Link>
                  </li>
                  <li>
                    <Link
                      to="#"
                      onClick={(e) => {
                        if (!isLogoutLoading) {
                          logoutHandler(e);
                        } else {
                          e.preventDefault(); // block clicks while disabled
                        }
                      }}
                      className={isLogoutLoading ? "disabled-link" : ""}
                      aria-disabled={isLogoutLoading}
                    >
                      <span className="iconnav">
                        <img src={SignoutIcon} alt="" className="img-fluid" />
                      </span>
                      <span className="txt ">
                        {isLogoutLoading ? (
                          <>
                            {t("sidenav.SIGNOUT.loading") || "Logging out…"}
                            <span
                              className="spinner-border spinner-border-sm ms-2"
                              role="status"
                              aria-hidden="true"
                            />
                          </>
                        ) : (
                          t("sidenav.SIGNOUT.detail")
                        )}
                      </span>
                    </Link>
                  </li>
                </ul>
              </div>
            </Offcanvas.Body>
          </div>
        </div>
      </Offcanvas>
    </>
  );
}

export default SideNav;
